export default __webpack_public_path__ + "static/asm2logo-748f066c1feaf8d742f8609b86363bf5.png";